import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
export function OfferSection() {
  return <section id="offer" className="bg-white py-12 md:py-16 scroll-mt-10" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4" data-id="element-162">
        <FadeIn data-id="element-163">
          <h2 className="text-4xl md:text-5xl font-bold text-brand-brown text-center mb-10" data-id="element-164">
            Todo lo que recibís hoy
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-165">
          {/* Main Product */}
          <FadeIn delay={0.1} data-id="element-166">
            <div className="bg-brand-cream-light border-2 border-brand-gold rounded-2xl p-6 md:p-8 shadow-warm-lg relative overflow-hidden" data-id="element-167">
              <div className="absolute top-0 right-0 bg-brand-gold text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-168">
                PRODUCTO PRINCIPAL
              </div>
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-169">
                <div className="flex-1" data-id="element-170">
                  <h3 className="text-2xl font-bold text-brand-brown mb-3 flex items-center" data-id="element-171">
                    <span className="mr-3 text-3xl" data-id="element-172">📘</span> El Arte de la
                    Milhojas Perfecta
                  </h3>
                  <p className="text-brand-brown/80 leading-relaxed" data-id="element-173">
                    El método completo de Stella Pereira. Desde la masa hasta el
                    montaje de 12 capas. Técnica de 38g por bollito, estirado
                    transparente, merengue italiano infalible y decoración
                    final.
                  </p>
                </div>
                <div className="text-right md:text-center shrink-0" data-id="element-174">
                  <span className="text-brand-brown/40 line-through text-xl font-bold block" data-id="element-175">
                    $15.900
                  </span>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* 3 Recetas Bonus — with image inside */}
          <FadeIn delay={0.2} data-id="element-176">
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm relative overflow-hidden" data-id="element-177">
              <div className="absolute top-0 left-0 bg-green-600 text-white text-xs font-bold px-4 py-1 rounded-br-lg z-10" data-id="element-178">
                🎁 BONO GRATIS
              </div>
              <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-179">
                <div className="flex-1 pt-4 md:pt-0" data-id="element-180">
                  <h4 className="text-xl font-bold text-brand-brown mb-2 flex items-center" data-id="element-181">
                    <span className="mr-3 text-2xl" data-id="element-182">🎁</span> 3 Recetas Bonus
                  </h4>
                  <p className="text-brand-brown/70 text-sm md:text-base" data-id="element-183">
                    Pavlova con Frutas Frescas, Tarta Ópera y Cheesecake de
                    Maracuyá. Tres recetas premium para ampliar tu repertorio.
                  </p>
                </div>
                <div className="text-right md:text-center shrink-0" data-id="element-184">
                  <span className="text-brand-brown/40 line-through text-lg font-bold block" data-id="element-185">
                    $76.000
                  </span>
                </div>
              </div>
              <div className="px-6 pb-6" data-id="element-186">
                <img src="https://cdn.magicpatterns.com/uploads/xeiJS2gN9PX3WLss8xpyTi/m3.png" alt="Bonos gratis incluidos con Milhojas de Stella" className="rounded-xl w-full" data-id="element-187" />
              </div>
            </div>
          </FadeIn>

          {/* Estrategia Instagram para Vender — with image inside */}
          <FadeIn delay={0.3} data-id="element-188">
            <div className="bg-white border border-gray-200 rounded-2xl shadow-sm relative overflow-hidden" data-id="element-189">
              <div className="absolute top-0 left-0 bg-green-600 text-white text-xs font-bold px-4 py-1 rounded-br-lg z-10" data-id="element-190">
                🎁 BONO GRATIS
              </div>
              <div className="p-6 flex flex-col md:flex-row md:items-center justify-between gap-6" data-id="element-191">
                <div className="flex-1 pt-4 md:pt-0" data-id="element-192">
                  <h4 className="text-xl font-bold text-brand-brown mb-2 flex items-center" data-id="element-193">
                    <span className="mr-3 text-2xl" data-id="element-194">🎁</span> Estrategia
                    Instagram para Vender tus Tortas
                  </h4>
                  <p className="text-brand-brown/70 text-sm md:text-base" data-id="element-195">
                    Guía paso a paso para vender y generar ingresos en redes
                    sociales con tus tortas. Aprendé a publicar, atraer clientes
                    y cobrar, incluso sin experiencia previa en ventas online.
                  </p>
                </div>
                <div className="text-right md:text-center shrink-0" data-id="element-196">
                  <span className="text-brand-brown/40 line-through text-lg font-bold block" data-id="element-197">
                    $5.900
                  </span>
                </div>
              </div>
              <div className="px-6 pb-6" data-id="element-198">
                <img src="https://cdn.magicpatterns.com/uploads/hKcnJ74Y2km1hebM8K2QcQ/COMBO_1.png" alt="Método Milhojas + Estrategia Instagram de Stella" className="rounded-xl w-full" data-id="element-199" />
              </div>
            </div>
          </FadeIn>

          {/* Contacto Directo con Stella — SPECIAL CARD */}
          <FadeIn delay={0.35} data-id="element-200">
            <div className="bg-gradient-to-br from-brand-gold-dark via-brand-gold to-brand-gold-dark rounded-2xl p-1 shadow-warm-lg" data-id="element-201">
              <div className="bg-gradient-to-br from-brand-dark-deep to-brand-dark rounded-xl p-6 md:p-8 relative overflow-hidden" data-id="element-202">
                <div className="absolute top-0 left-0 bg-brand-orange text-white text-xs font-bold px-5 py-1.5 rounded-br-xl" data-id="element-203">
                  ⭐ BONO EXCLUSIVO
                </div>
                <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/10 rounded-full blur-2xl" data-id="element-204"></div>

                <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 pt-4" data-id="element-205">
                  <div className="flex-1" data-id="element-206">
                    <h4 className="text-2xl font-bold text-white mb-3 flex items-center" data-id="element-207">
                      <span className="mr-3 text-3xl" data-id="element-208">💬</span> Contacto Directo
                      con Stella
                    </h4>
                    <p className="text-brand-cream/80 md:text-lg leading-relaxed" data-id="element-209">
                      Acceso ilimitado para consultar{' '}
                      <span className="text-brand-gold font-bold" data-id="element-210">
                        todas tus dudas por mensaje
                      </span>
                      . Comunicate con Stella en cualquier momento para que no
                      te quedes trabada en ningún paso del proceso.{' '}
                      <span className="text-brand-gold italic" data-id="element-211">
                        ¡Stella te responde personalmente!
                      </span>
                    </p>
                  </div>
                  <div className="text-right md:text-center shrink-0" data-id="element-212">
                    <span className="text-white/40 line-through text-lg font-bold block" data-id="element-213">
                      $30.000
                    </span>
                    <span className="text-brand-gold text-sm font-bold" data-id="element-214">
                      INCLUIDO
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Value Summary — Anchoring Style */}
        <FadeIn delay={0.6} data-id="element-215">
          <div className="mt-10 bg-brand-cream border border-brand-gold/30 rounded-3xl p-8 md:p-12 shadow-warm-lg" data-id="element-216">
            <h3 className="text-2xl font-bold text-brand-brown mb-6" data-id="element-217">
              Lo que obtendrás:
            </h3>
            <div className="space-y-4 mb-8" data-id="element-218">
              <div className="flex items-start gap-3" data-id="element-219">
                <span className="text-xl mt-0.5" data-id="element-220">📘</span>
                <p className="text-brand-brown" data-id="element-221">
                  <span className="font-bold" data-id="element-222">Método Milhojas Perfecta:</span>{' '}
                  La receta completa paso a paso
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-223">
                <span className="text-xl mt-0.5" data-id="element-224">💰</span>
                <p className="text-brand-brown" data-id="element-225">
                  <span className="font-bold" data-id="element-226">Estrategia Instagram:</span> Guía
                  paso a paso para vender tus milhojas en redes sociales
                  (incluso sin experiencia)
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-227">
                <span className="text-xl mt-0.5" data-id="element-228">🧁</span>
                <p className="text-brand-brown" data-id="element-229">
                  <span className="font-bold" data-id="element-230">3 Recetas Bonus:</span> Pavlova,
                  Tarta Ópera y Cheesecake de Maracuyá
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-231">
                <span className="text-xl mt-0.5" data-id="element-232">💬</span>
                <p className="text-brand-brown" data-id="element-233">
                  <span className="font-bold" data-id="element-234">Contacto Directo:</span> Consultá
                  tus dudas con Stella por mensaje
                </p>
              </div>
            </div>

            {/* Price Anchoring Table */}
            <div className="border-t border-brand-gold/30 pt-6 mb-8" data-id="element-235">
              <div className="space-y-3" data-id="element-236">
                <div className="flex justify-between items-center text-brand-brown" data-id="element-237">
                  <span data-id="element-238">Método Milhojas:</span>
                  <span className="font-bold" data-id="element-239">$15.900</span>
                </div>
                <div className="flex justify-between items-center text-brand-brown" data-id="element-240">
                  <span data-id="element-241">Estrategia Instagram:</span>
                  <span className="font-bold" data-id="element-242">$5.900</span>
                </div>
                <div className="flex justify-between items-center text-brand-brown" data-id="element-243">
                  <span data-id="element-244">3 Recetas Bonus:</span>
                  <span className="font-bold" data-id="element-245">$76.000</span>
                </div>
                <div className="flex justify-between items-center text-brand-brown" data-id="element-246">
                  <span data-id="element-247">Contacto Directo:</span>
                  <span className="font-bold" data-id="element-248">$30.000</span>
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-brand-gold/30" data-id="element-249">
                  <span className="font-bold text-lg text-brand-brown" data-id="element-250">
                    Valor Total:
                  </span>
                  <span className="font-black text-lg text-brand-brown line-through" data-id="element-251">
                    $127.800
                  </span>
                </div>
              </div>
            </div>

            {/* Final Price & CTA */}
            <div className="text-center" data-id="element-252">
              <p className="text-5xl md:text-6xl font-black text-brand-red mb-6" data-id="element-253">
                PRECIO HOY: $10.200
              </p>

              <CTAButton fullWidth isPayment className="py-6 text-xl md:text-2xl mb-6" data-id="element-254">
                🛒 Sí, quiero aprender el método ahora
              </CTAButton>

              {/* Payment Method Icons */}
              <div className="flex flex-wrap justify-center items-center gap-4 mt-4" data-id="element-255">
                <span className="text-sm text-brand-brown/50 font-medium" data-id="element-256">
                  Medios de pago:
                </span>
                <div className="flex items-center gap-3" data-id="element-257">
                  <div className="bg-white border border-gray-200 rounded-lg px-3 py-1.5 shadow-sm" data-id="element-258">
                    <span className="font-bold text-blue-800 text-sm tracking-wider" data-id="element-259">
                      VISA
                    </span>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg px-3 py-1.5 shadow-sm" data-id="element-260">
                    <div className="flex items-center gap-0.5" data-id="element-261">
                      <div className="w-4 h-4 bg-red-500 rounded-full opacity-80" data-id="element-262"></div>
                      <div className="w-4 h-4 bg-yellow-500 rounded-full -ml-2 opacity-80" data-id="element-263"></div>
                    </div>
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg px-2 py-1 shadow-sm" data-id="element-264">
                    <img src="https://cdn.magicpatterns.com/uploads/n6Us3NWUWRCkRk1qvu7EUL/pasted-image.png" alt="Mercado Pago" className="h-6 w-auto" data-id="element-265" />
                  </div>
                  <div className="bg-white border border-gray-200 rounded-lg px-3 py-1.5 shadow-sm" data-id="element-266">
                    <span className="font-bold text-[#003087] text-sm" data-id="element-267">
                      Pay<span className="text-[#009CDE]" data-id="element-268">Pal</span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}